export default {
  'component.user.logout': '退出',
  'component.user.preferences': '偏好设置',
  'component.user.unactivated': '未激活',
  'component.auth.title': '授权认证',
  'component.auth.username': '用户名',
  'component.auth.password': '密码',
  'component.phoneInput.invalid': '无效的手机号',
  'component.passwordInput.title': '请输入密码以验证您的帐户',
  'component.passwordInput.placeholder': '输入密码',
  'component.action.acknowledge': '我认可',
  'component.action.colorpicker': '菜品颜色选择',
  'component.employee.multiple': '按员工筛选，可多选',
  'component.employee.single': '按员工筛选',
  'component.restaurant.filter': '根据餐厅名筛选',
  'component.multiple_order_source.filter': '按订单来源筛选, 可多选',
  'component.platforms.filter': '按平台搜索，可多选',
  'component.multiple_service_type.filter': '按服务类型筛选，可多选',
  'component.loadRestaurantGroupFailed': '加载餐厅列表失败',
  'component.advancedSearch.title': '高级搜素',
  'component.advancedSearch.keyword': '关键字',
  'component.advancedSearch.type': '类型',
  'component.advancedSearch.keyword.placeholder': '按{fieldName}搜索',
  'component.advancedSearch.showKeyword.placeholder': '按{fieldName}关键词搜索',
  'component.qrLinked': '已绑定',
  'component.reset_login_password': '重设登录密码',
};
